import { isValidASTerm } from "client/utils/helpers";
import type { ASResponse, SearchResponse } from "types/searchApi/response";
import type { ASReqOptions } from "./autosuggest-service";

export interface WorkerParams {
  type?: "autosuggest" | "recommendations";
  searchTerm?: string;
  options?: ASReqOptions;
  env: {
    SEARCH_API_BASE_URL: string;
  };
}

export declare class AutosuggestWorker extends globalThis.Worker {
  constructor();
  postMessage(data: WorkerParams): void;
  onmessage: (ev: MessageEvent<ASResponse | SearchResponse | null>) => void;
}

export interface AutosuggestWorkerImpl {
  postMessage(data: ASResponse | SearchResponse | null): void;
  onmessage: (ev: MessageEvent<WorkerParams>) => void;
}

declare const self: AutosuggestWorkerImpl & WindowOrWorkerGlobalScope;
declare const Worker: typeof AutosuggestWorker;

const getResults = async ({
  type,
  searchTerm,
  options,
}: Pick<WorkerParams, "type" | "searchTerm" | "options">) => {
  const { getRecommendations, getAutosuggestResults } = await import(
    "./autosuggest-service"
  );

  if (type === "recommendations" || !isValidASTerm(searchTerm)) {
    return getRecommendations(options);
  }

  return getAutosuggestResults(searchTerm, options);
};

export const messageHandler: AutosuggestWorkerImpl["onmessage"] = async ({
  data: { type, searchTerm, options, env },
}) => {
  self.SEARCH_API_BASE_URL = new URL(
    env.SEARCH_API_BASE_URL,
    env.SEARCH_API_BASE_URL.includes("http") ? undefined : location.origin,
  ).toString();

  const res = await getResults({ type, searchTerm, options });

  self.postMessage(res);
};

self.onmessage = messageHandler;
export default Worker;
